module.exports = __webpack_public_path__ + "img/20200512_161939.d2135af7.jpg";